import styled from '@emotion/styled';

export const FlexGridCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;  
    width: 100%;     
`;

export const FlexDiv = styled.div`
    display: flex;
    align-items: center;
`;

export const CardSpan = styled.span`
    margin-right: 5px;
    font-size: 14px
`;